import { Component, Input, ChangeDetectionStrategy, ChangeDetectorRef, OnInit } from '@angular/core';
import { Question } from '../../../../classes';
import { Subscription } from 'rxjs';
@Component({
    selector: 'question-settings',
    templateUrl: './question-settings.component.html',
    styleUrls: ['./question-settings.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
 
})
export class QuestionSettingsComponent implements OnInit {
    @Input() question:Question;
    supportedTypes:string[];
    subscriptions:Subscription[] = [];
    constructor (
        private cdRef:ChangeDetectorRef,
    ) {}
    ngOnInit () {
        this.supportedTypes = this.question.survey.supportedQuestionTypes;        
        this.subscriptions.push(this.question.onContentUpdate.subscribe(()=>this.cdRef.detectChanges()))
    }
    ngOnDestroy () {
        this.subscriptions.forEach(sub=>sub.unsubscribe());
    }

    copy () {
        this.question.survey.copyQuestion(this.question);
        this.question.survey.pasteQuestions(this.question.priority + 1 + this.question.getDecendantQuestions().length);
    }
    delete () {
        this.question.survey.deleteQuestions({id:this.question.id});
    }
}
